export function searchInputHtml() {
  return `_INPUT_
  <span class="fa fa-filter search-filter"></span>
    <div class="dt-filter__container">
      <div class="dt-filter__inner">
      <button class="btn btn-outline-secondary dropdown-toggle btn-sm dt-filter-drp-btn" type="button" data-toggle="dropdown" aria-label="Category dropdown" data-target="#document-filter-dropdown" aria-haspopup="true" aria-expanded="false"><span class="sr-only">Category dropdown</span> </button>
      <button class="btn btn-sm dt-filter-search-btn" type="button" aria-label="Search">
          <i class="fa fa-search" aria-hidden="true"></i>
        </button>
      </div>
    </div>`;
}

export function restorePersistedFilterState(
  caseId,
  { attachmentsInputTarget, filterFolderInputTarget },
) {
  attachmentsInputTarget.checked = persistedAttachmentsVisible(caseId);
  filterFolderInputTarget.checked = persistedFolderPanelVisible(caseId);
  return persistedFilterFolderId(caseId);
}

export function updateFilterCounts(
  documentCounts,
  { filterTargets, attachmentsTarget },
) {
  let { deleted, attachments, ...counts } = documentCounts;

  filterTargets.forEach((node) => {
    const filter = node.dataset.documentListFilterParam;
    if (filter === "all") {
      updateNavPill(
        node,
        Object.values(counts).reduce((a, b) => a + b),
      );
    } else {
      if (filter === "docs") {
        updateNavPill(node, counts.documents);
      } else if (filter === "wordDocs") {
        updateNavPill(node, counts.wordDocuments);
      } else if (filter === "pdfs") {
        updateNavPill(node, counts.pdfDocuments);
      } else if (filter === "audio") {
        updateNavPill(node, counts.audioDocuments);
      } else if (filter === "deleted") {
        updateNavPill(node, deleted);
      } else {
        updateNavPill(node, counts[filter]);
      }
    }
  });
  setBadge(attachmentsTarget, attachments);
}

function updateNavPill(target, value) {
  setBadge(target, value);
  target.classList.toggle("disabled", value === 0);
  target.ariaDisabled = value === 0 ? "true" : "false";
}

function setBadge(node, value) {
  if (value === 0) {
    node.querySelector(".badge").textContent = "";
  } else {
    node.querySelector(".badge").textContent = value;
  }
  node.querySelector(".badge").classList.toggle("badge-zero", value === 0);
}

export function persistAttachmentsVisible(caseId, state) {
  localStorage.setItem(attachmentsVisibleKey(caseId), state);
}

export function persistedAttachmentsVisible(caseId) {
  return localStorage.getItem(attachmentsVisibleKey(caseId)) === "true";
}

export function attachmentsVisibleKey(caseId) {
  return `isShowAttachmentChecked_${caseId}`;
}

export function persistFolderState(caseId, panelVisible, filterFolderId) {
  localStorage.setItem(folderPanelVisibleKey(caseId), panelVisible);
  if (filterFolderId == null) {
    localStorage.removeItem(filterFolderIdKey(caseId));
  } else {
    localStorage.setItem(filterFolderIdKey(caseId), filterFolderId);
  }
}

export function persistedFolderPanelVisible(caseId) {
  return localStorage.getItem(folderPanelVisibleKey(caseId)) === "true";
}

export function persistedFilterFolderId(caseId) {
  return localStorage.getItem(filterFolderIdKey(caseId));
}

export function folderPanelVisibleKey(caseId) {
  return `isViewFoldersChecked_${caseId}`;
}

export function filterFolderIdKey(caseId) {
  return `${caseId}_folderId`;
}
